import { handlePageTitle } from "containers/pmaInventoryIncrease/services/data.transformers";
import { useTranslation } from "react-i18next";
import PageHeader from "./header";
import { Layout } from "antd";
import { useEffect, useState } from "react";
import { INVENTORY_INCREASE_STATUS } from "containers/pmaInventoryIncrease/services/data.transformers";

const { Content } = Layout;
const PageLayout = ({ children, currentStage, onBack, onClose }) => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) return setIsScrolled(true);

    setIsScrolled(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="items-center increase-layout !bg-gray--12 max-w-2xl  w-full m-auto flex flex-col h-[100vh]">
      <PageHeader
        isScrolled={isScrolled}
        title={handlePageTitle({ currentStage, translate: t })}
        isShowBack={currentStage !== INVENTORY_INCREASE_STATUS.RECEIPT}
        onBack={onBack}
        onClose={onClose}
      />
      <div className="w-full max-w-2xl pt-12">
        <Content className="overflow-auto overflow-x-hidden pb-24">
          {children}
        </Content>
      </div>
    </div>
  );
};
export default PageLayout;
